import React from 'react';
import jwt from 'jsonwebtoken';
import { StateProvider } from './State';
import { encode, decode } from './Service/Utils';
import AppWithLoader from './AppWithLoader';
import permissions from './permissions';
import './styles.scss';

export const initialState = {
    token: null,
    loggedin: true,
    loading: false,
    role: {},
    user: {},
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_LOADING':
            return {
                ...state,
                loading: action.value,
            };

        case 'SIGN_IN':
            localStorage.setItem('t', encode(action.value.token));
            localStorage.setItem('r', jwt.sign(action.value.role, 'feelsecure'));
            localStorage.setItem('u', jwt.sign(action.value.user, 'feelsecure'));
            return {
                ...state,
                loggedin: true,
                token: action.value.token,
                role: action.value.role,
                user: action.value.user,
            };

        case 'LOAD_SESSION': {
            let tokenSession = localStorage.getItem('t');
            let roleSession = localStorage.getItem('r');
            let userSession = localStorage.getItem('u');

            try {
                tokenSession = decode(tokenSession);
                roleSession = jwt.verify(roleSession, 'feelsecure');
                userSession = jwt.verify(userSession, 'feelsecure');
            } catch (e) {
                localStorage.clear();
                return {
                    ...state,
                    loggedin: false,
                    token: null,
                };
            }

            return {
                ...state,
                loggedin: true,
                token: tokenSession,
                role: roleSession,
                user: userSession,
            };
        }

        case 'CHECK_PERMISSIONS': {
            let valid = false;
            const item = permissions && permissions.find((v) => v.role === action.value.role);
            if (item) {
                valid = item.routes.includes(action.value.path);
            }
            if (!valid) {
                localStorage.clear();
                return {
                    ...state,
                    loggedin: false,
                    token: null,
                };
            }
            return state;
        }

        case 'EXIT':
            localStorage.clear();
            return {
                ...state,
                loggedin: false,
                token: null,
            };

        default:
            return state;
    }
};

const App = () => (
    <StateProvider initialState={initialState} reducer={reducer}>
        <AppWithLoader />
    </StateProvider>
);

export default App;
